<template lang="pug">
.filter-item(v-show="filter.count > 0 || selected")
  input.filter-item__input(
    v-model="selected",
    type="checkbox",
    :id="filter.id")
  label.filter-item__label(:for="filter.id") {{ display }}
</template>

<script>
import { mapMutations } from 'vuex';

export default {
  name: "SearchFiltersItem",
  props: ["filter", "groupID"],
  data() {
    return { };
  },
  computed: {
    display() {
      return this.filter.value + " (" + this.filter.count + ")";
    },
    selected: {
      get() {
        return this.filter.selected;
      },
      set(value) {
        const data = {
          groupID: this.groupID,
          id: this.filter.id,
          value
        };
        this.setFilterItem(data);
      }
    }
  },
  methods: {
    ...mapMutations(['setFilterItem'])
  },
  created() {
    if (this.$route.query.c) {
      let filters = this.$route.query.c.split(',')
      if (filters.includes(this.filter.id)) {
        this.selected = true;
      }
    }
  }
};
</script>


<style lang="scss" scoped>
	.filter-item {
		display: flex;
		flex-direction: column;
		position: relative;
		flex: 0 0 auto;
		font-size: 1.125rem;
		&:not(:last-child) {
			margin-bottom: 0.875rem;
		}

		&__input {
			@include hideVisually;
			&:focus:not(body.using-mouse *) {
				& + .filter-item__label {
					box-shadow: 0 0 0 2px $darkGray;
					&::before {
						color: darken($lightGray, 10%);
					}
				}
			}
			&:checked + .filter-item__label {
				&::before {
					background-color: $primaryPurple;
					color: $white;
					border-color: $primaryPurple;
				}
			}
		}

		&__label {
			display: flex;
			cursor: pointer;
			align-items: flex-start;
			text-align: left;
			font-size: 0.875rem;
			line-height: 1.5;
			&::before {
				@include icon("check");
				display: flex;
				justify-content: center;
				align-items: center;
				height: 1.25rem;
				width: 1.25rem;
				flex: 0 0 1.25rem;
				margin-right: 0.75rem;
				font-size: 1rem;
				color: transparent;
				border: 1px solid $mediumGray;
				transition: 0.25s ease;
			}
		}
	}
</style>